import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const PAGE_INITIAL = { opacity: 0, y: 14 };
const PAGE_VISIBLE = { opacity: 1, y: 0 };
const PAGE_TRANSITION = { duration: 0.45, ease: [0.22, 1, 0.36, 1] };
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import PostDetail from "@/pages/PostDetail";
import TagPage from "@/pages/TagPage";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAnalytics from "@/pages/AdminAnalytics";
import PostEditor from "@/pages/PostEditor";
import SocialManager from "@/pages/SocialManager";

function AppRouter() {
    const location = useLocation();
    React.useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
    return (
        <>
            <Header />
            <motion.main
                key={location.pathname}
                initial={PAGE_INITIAL}
                animate={PAGE_VISIBLE}
                transition={PAGE_TRANSITION}
            >
                <Routes location={location}>
                    <Route path="/" element={<Home />} />
                    <Route path="/category/:cat" element={<Category />} />
                    <Route path="/post/:slug" element={<PostDetail />} />
                    <Route path="/tag/:tag" element={<TagPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/analytics" element={<AdminAnalytics />} />
                    <Route path="/admin/social" element={<SocialManager />} />
                    <Route path="/admin/new" element={<PostEditor />} />
                    <Route path="/admin/edit/:id" element={<PostEditor />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </motion.main>
            <Footer />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <AppRouter />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
